export default function Down(status) {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={status.status ? "0.2" : "0.6"} clipPath="url(#clip0_3_17585)">
        <path d="M25 10.4167V39.5834" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M37.5 27.0833L25 39.5833"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 27.0833L25 39.5833"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_17585">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
